/*
 Plugin to add or remove the required marker on a simple_form's field

 Use:
  To add the marker and unlock the field
  $("#field").fieldRequiredMarker()

  Remove the marker, lock the field e set the value to ""
  $("#field").fieldRequiredMarker({ remove_mark: true, disable: true }).val("");
*/
/* eslint-disable */
(function ($) {
  $.fn.appendAbbr = function () {
    const $that = $(this);

    if ($that.find('abbr').length < 1) {
      $that.append(' <abbr title="obrigatório">*</abbr>');
    }

    return $that;
  };

  $.fn.fieldRequiredMarker = function (givedOptions) {
    const options = {
      remove_mark: false,
      disable: false,
    };

    $.extend(options, givedOptions);

    const $that = $(this);

    if (options.remove_mark) {
      $that
        .removeClass('required')
        .closest('div')
        .removeClass('required')
        .find('label')
        .removeClass('required')
        .find('abbr')
        .remove();
    } else {
      $that
        .addClass('required')
        .closest('div')
        .addClass('required')
        .find('label')
        .addClass('required')
        .appendAbbr();
    }

    if (options.disable) {
      $that.addClass('disabled').attr('disabled', 'disabled');
    } else {
      $that.removeClass('disabled').removeAttr('disabled');
    }

    return $that;
  };
}(jQuery));
